import {
    DocumentData,
    DocumentReference,
    addDoc,
    collection,
    deleteDoc,
    doc,
    getDoc,
    getDocs,
    setDoc,
    updateDoc,
} from 'firebase/firestore';
import { db, storage } from './firebase-config';
import { ref, uploadBytes } from 'firebase/storage';
import { FirestoreDocType } from './types';

export const getFirestoreDoc = async (docRef: DocumentReference<unknown, DocumentData>) =>
    getDoc(docRef);

export const getFirestoreDocs = async (collectionName: string) => {
    const collectionRef = collection(db, collectionName);
    const data = await getDocs(collectionRef);
    const filteredData = data.docs.map((doc) => ({ ...doc.data(), document_id: doc.id }));
    return filteredData;
};

export const addFirestoreDocs = async (collectionName: string, data: FirestoreDocType) => {
    const collectionRef = collection(db, collectionName);
    const ref = await addDoc(collectionRef, data);
    return ref;
};

export const deleteFirestoreDocs = async (collectionName: string, id: string) => {
    const selectedDoc = doc(db, collectionName, id);
    await deleteDoc(selectedDoc);
};

export const onUpdateDoc = async (
    collectionName: string,
    doc_id: string,
    data: FirestoreDocType,
) => {
    const selectedDoc = doc(db, collectionName, doc_id);
    await updateDoc(selectedDoc, data);
};

export const uploadFirestoreFile = async (file: File) => {
    if (!file) {
        return;
    }
    const filesFolderRef = ref(storage, `projectsFiles/${file.name}`);
    await uploadBytes(filesFolderRef, file);
};

export const setFirestoreDoc = async (
    collectionName: string,
    document_id: string,
    data: FirestoreDocType,
) => {
    const selectedDoc = doc(db, collectionName, document_id);
    await setDoc(selectedDoc, data);
};
